export const BANNER_DIMENSION = {
  WEB: {
    width: 1920,
    height:610,
  },
  MOBILE: {
    width: 393,
    height: 170,
  },
};